import { atom } from 'recoil'
import { ParsedPhoneNumber } from '../../utils/helpers/PhoneNumberHelper/PhoneNumberHelper'

export type ReDirectionAtomType = {
  loadId: string
  pathname: string
  tripLegId: string
  type: string
  email: string
  phoneNumber: ParsedPhoneNumber | null
  country: string
  source: string
}

const DEFAULT_STATE = {
  loadId: '',
  pathname: '',
  tripLegId: '',
  type: '',
  email: '',
  phoneNumber: null,
  country: '',
  source: '',
}

export const reDirectionAtom = atom<ReDirectionAtomType>({
  key: 'reDirectionAtomType',
  default: DEFAULT_STATE,
})

export const remoteSourceAtom = atom<string>({
  key: 'string',
  default: '',
})
